import { getEmptyAdjacentRectangles } from "./getEmptyAdjacentRectangles";
import { canBubbleFitInRectangle } from "./canBubbleFitInRectangle";
import { placeBubbleInRectangle } from "./placeBubbleInRectangle";

export function computeBubblesPositionsAndContainerSize(bubbles, spacing) {
  if (bubbles.length === 0) {
    return [[], [0, 0]];
  }

  let computedContainerWidth = bubbles[0].size.width + spacing;
  let computedContainerHeight = bubbles[0].size.width + spacing;
  const placedRectangles = [];
  let refRectangleIndex = 0;
  const computedBubbles = [];
  let i = 0;

  while (i < bubbles.length) {
    const bubble = bubbles[i];
    const emptyRectangles = getEmptyAdjacentRectangles(
      placedRectangles,
      refRectangleIndex,
      computedContainerWidth,
      computedContainerHeight
    );

    const fitEmptyRectangles = emptyRectangles.filter((emptyRectangle) => {
      return canBubbleFitInRectangle(bubble, emptyRectangle, spacing);
    });

    if (fitEmptyRectangles.length > 0) {
      const index = Math.floor(Math.round(bubble.percent + i)) % fitEmptyRectangles.length;
      const bubbleCoordinates = placeBubbleInRectangle(
        bubble,
        fitEmptyRectangles[index],
        placedRectangles,
        refRectangleIndex,
        spacing
      );

      computedBubbles.push({
        ...bubble,
        left: bubbleCoordinates[0],
        top: bubbleCoordinates[1],
      });
      placedRectangles.push(bubbleCoordinates);
      i++;
    } else if (refRectangleIndex < placedRectangles.length - 1) {
      refRectangleIndex++;
    } else {
      refRectangleIndex = 0;
      computedContainerWidth += bubble.size.width;
      computedContainerHeight += bubble.size.width;
    }
  }

  return [computedBubbles, [computedContainerWidth, computedContainerHeight]];
}
